import { useTranslation } from 'libs/i18n'

export const useActionFilters = (isDisabled: boolean) => {
	const { t } = useTranslation()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				{
					value: 'export',
					label: t('Export'),
					isDisabled
				},
				{
					value: 'delete',
					label: t('Delete'),
					isDisabled
				}
			]
		}
	]
}
